import posthog from 'posthog-js'

export const handleError = (error, info = {}) => {
    try {

        // Normalize the error to an Error object so we get the proper error on the Posthog console
        if (!(error instanceof Error)) {
            info = { ...info, error }
            const errorMessage = typeof error === 'string' ? error : JSON.stringify(error)
            error = new Error(errorMessage, { cause: error })
        }

        posthog.captureException(error, info)
        console.error(error)

    } catch (e) {
        console.error('Failed report error to Posthog')
        console.error(e)
    }

}
